"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Insurances;
const jsx_runtime_1 = require("react/jsx-runtime");
const link_1 = __importDefault(require("@kawaui/link"));
const popover_1 = __importDefault(require("@kawaui/popover"));
const facil_iti_button_1 = __importDefault(require("@narf/facil-iti-button"));
const types_1 = require("../../types");
const Styles = __importStar(require("./styles"));
const getImageWidth = (id) => {
    switch (id) {
        case types_1.ServiceId.Sourdline:
            return '140px';
        case types_1.ServiceId.Faciliti:
            return '130px';
        default:
            return '50px';
    }
};
function Insurances({ items }) {
    return ((0, jsx_runtime_1.jsx)(Styles.InsuranceContainer, { children: items.map((service) => {
            const child = service.info ? ((0, jsx_runtime_1.jsx)(popover_1.default, { variant: "secondary", content: service.info, placement: "top", enableHover: true, children: (0, jsx_runtime_1.jsx)(Styles.Image, Object.assign({ loading: "lazy", width: getImageWidth(service.id), height: "50px" }, service.image)) })) : ((0, jsx_runtime_1.jsx)(Styles.Image, Object.assign({ loading: "lazy", width: getImageWidth(service.id), height: "50px" }, service.image)));
            const Item = service.linkRedirection
                ? link_1.default
                : (_a) => {
                    var { children } = _a, otherProps = __rest(_a, ["children"]);
                    return (0, jsx_runtime_1.jsx)("span", Object.assign({}, otherProps, { children: children }));
                };
            return ((0, jsx_runtime_1.jsx)(Item, { target: service.target, href: service.linkRedirection, title: service.linkTitle, children: (service === null || service === void 0 ? void 0 : service.id) === types_1.ServiceId.Faciliti ? (0, jsx_runtime_1.jsx)(facil_iti_button_1.default, {}) : child }, `${service.id}-${service.image.src}`));
        }) }));
}
